const CommonTableActions = [
  {
    label: 'forms.edit',
    eventName: 'edit',
    icon: 'Edit2Icon',
  },
  {
    label: 'forms.delete',
    eventName: 'delete',
    icon: 'Trash2Icon',
  },
]

export default CommonTableActions
